import React, { useState } from 'react';
import { FaDownload, FaArrowLeft } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoicePDF from "./Pdf2";

const QuotationDetails = () => {
    const [quotationData] = useState({
        quotationNumber: 'QT-2023-00125',
        date: 'October 15, 2023',
        from: {
            company: 'A2Z Marine Supplies',
            address: '123 Harbor View Road, Maritime District',
            city: 'Mumbai',
            state: 'Maharashtra',
            postalCode: '400001',
            country: 'India',
            phone: '+91 22 1234 5678',
            email: 'sales@a2zmarine.com'
        },
        to: {
            company: 'Oceanic Shipping Ltd.',
            attention: 'Mr. Robert Johnson, Procurement Manager',
            address: '456 Seafront Avenue, Port Zone',
            city: 'Chennai',
            state: 'Tamil Nadu',
            postalCode: '600001',
            country: 'India',
            phone: '+91 44 8765 4321',
            email: 'procurement@oceanicshipping.com'
        },
        items: [
            {
                id: 1,
                description: 'Marine Diesel Engine Spare Parts Kit',
                partNumber: 'MDE-2023-SPK',
                quantity: 2,
                unitPrice: 12500,
                total: 25000
            },
            {
                id: 2,
                description: 'Hydraulic Pump Assembly',
                partNumber: 'HPA-4500-M',
                quantity: 1,
                unitPrice: 38750,
                total: 38750
            },
            {
                id: 3,
                description: 'Navigation System Maintenance',
                partNumber: 'NS-MNT-2023',
                quantity: 1,
                unitPrice: 15200,
                total: 15200
            }
        ],
        subtotal: 78950,
        tax: 10, // percentage
        taxAmount: 7895,
        shipping: 2500,
        total: 89345,
        notes: 'This quotation is valid for 30 days from the date of issue. Prices are in Indian Rupees.'
    });

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
        }).format(amount);
    };

    return (
        <div className="container mt-4">
            {/* Header with back button and title */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <button className="btn btn-secondary">
                    <FaArrowLeft className="me-1" /> Back
                </button>
                <h2 className="text-primary mb-0">Quotation Details</h2>
                 <PDFDownloadLink
                    document={<InvoicePDF data={quotationData} />}
                    fileName="quotation.pdf"
                  >
                    {({ loading }) => (
                      <button className="btn btn-primary">
                        <FaDownload className="me-1" />
                        {loading ? "Preparing PDF..." : "Download PDF"}
                      </button>
                    )}
                  </PDFDownloadLink>
            </div>

            {/* Quotation header with number and date */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <h4 className="text-primary">{quotationData.from.company}</h4>
                            <p className="mb-1">{quotationData.from.address}</p>
                            <p className="mb-1">{quotationData.from.city}, {quotationData.from.state} {quotationData.from.postalCode}</p>
                            <p className="mb-1">{quotationData.from.country}</p>
                            <p className="mb-1">Phone: {quotationData.from.phone}</p>
                            <p className="mb-0">Email: {quotationData.from.email}</p>
                        </div>
                        <div className="col-md-6 text-end">
                            <h3 className="text-primary">QUOTATION</h3>
                            <p className="mb-1"><strong>Quotation No:</strong> {quotationData.quotationNumber}</p>
                            <p className="mb-1"><strong>Date:</strong> {quotationData.date}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* To section */}
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="card-title text-primary">To:</h5>
                    <p className="mb-1"><strong>{quotationData.to.company}</strong></p>
                    <p className="mb-1">Attn: {quotationData.to.attention}</p>
                    <p className="mb-1">{quotationData.to.address}</p>
                    <p className="mb-1">{quotationData.to.city}, {quotationData.to.state} {quotationData.to.postalCode}</p>
                    <p className="mb-1">{quotationData.to.country}</p>
                    <p className="mb-1">Phone: {quotationData.to.phone}</p>
                    <p className="mb-0">Email: {quotationData.to.email}</p>
                </div>
            </div>

            {/* Products table */}
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="card-title text-primary">Products / Services</h5>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-primary">
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Part Number</th>
                                    <th className="text-center">Quantity</th>
                                    <th className="text-end">Unit Price</th>
                                    <th className="text-end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quotationData.items.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.description}</td>
                                        <td>{item.partNumber}</td>
                                        <td className="text-center">{item.quantity}</td>
                                        <td className="text-end">{formatCurrency(item.unitPrice)}</td>
                                        <td className="text-end">{formatCurrency(item.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Price summary */}
            <div className="row justify-content-end">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-primary">Price Summary</h5>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Subtotal:</span>
                                <span>{formatCurrency(quotationData.subtotal)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Tax ({quotationData.tax}%):</span>
                                <span>{formatCurrency(quotationData.taxAmount)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Shipping:</span>
                                <span>{formatCurrency(quotationData.shipping)}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between mb-2 fw-bold">
                                <span>Total:</span>
                                <span>{formatCurrency(quotationData.total)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Notes */}
            <div className="card mt-4">
                <div className="card-body">
                    <h5 className="card-title text-primary">Notes</h5>
                    <p>{quotationData.notes}</p>
                </div>
            </div>
        </div>
    );
};

export default QuotationDetails;